import React, { useContext, useState } from "react";
import SparklneChart from "assets/images/graph/SparklneChart.svg";

import RiskIndicator from "pages/Home/components/RiskIndicator/RiskIndicator";
import FlowChart from "../../components/FlowChart/FlowChart";
import MapBox from "../../components/MapBox/MapBox";
import { GeoRiskData } from "../Scan/data/MapData";
import MapFlow from "./components/MapFlow/MapFlow";
import AppDataContext from "context/AppDataContext";
import RiskBarChart from "assets/images/temp/RiskBarChart.svg";
import SparkLineChart from "components/SparkLineChart/SparkLineChart";
import VerticalBarChart from "components/VerticalBarChart/VerticalBarChart";

export default function AffectedRegion() {
  const { setGridModalShow, setToggleModal } = useContext(AppDataContext);
  const [navText, setNavigation] = useState('map');

  const riskData = [
    {
      title: "Financial",
      value: 49,
      isActive: true,
      isOnRisk: true,
    },
    {
      title: "Operations",
      value: 42,
      isActive: false,
      isOnRisk: false,
    },
    {
      title: "Regulatory",
      value: 21,
      isActive: true,
      isOnRisk: true,
    },
    {
      title: "Fraud",
      value: 27,
      isActive: false,
      isOnRisk: true,
    },
    {
      title: "Strategic",
      value: 42,
      isActive: false,
      isOnRisk: false,
    },
  ];

  const renderSwitch = () => {
    switch (navText) {
      case "map":
        return (
          <MapBox
            mapHeight="8rem"
            zoom={2.75}
            showControl={true}
            riskMarkers={GeoRiskData}
          />
        );
      case "flow":
        return <FlowChart />;
      case "mapFlow":
        return <MapFlow />;
    }
  };

  const openModal = () => {
    setGridModalShow(true);
    setToggleModal(true);
  }

  return (
    <div className="row fh ">
      <div className="col-9 fh ph-5 pt-5 center-column">
        <div className="mv-2 d-flex align-items-center justify-content-between ">
          {/* Switch */}

          <div className="btn-group">
            <button
              onClick={() => setNavigation("map")}
              className={`btn btn-outline-secondary  ${
                navText === "map" && "bg-primary"
              }`}
            >
              <i className="icon-map-pin mr-1"></i>
              Map
            </button>
            <button
              onClick={() => setNavigation("flow")}
              className={`btn btn-outline-secondary  ${
                navText === "flow" && "bg-primary"
              }`}
            >
              <i className="icon-git-pull-request mr-1"></i>
              Flow
            </button>
            <button
              onClick={() => setNavigation("mapFlow")}
              className={`btn btn-outline-secondary  ${
                navText === "mapFlow" && "bg-primary"
              }`}
            >
              <i className="icon-columns mr-1"></i>
              Map + Flow
            </button>
          </div>

          <button
            onClick={() => openModal()}
            className="btn btn-flat text-white"
          >
            <i className="icon-grid text-2x"></i>
          </button>
        </div>

        {renderSwitch()}
      </div>
      <div className="col pt-4 fh ph-5 rhs">
        <h3 className="widget-title mt-5">Overview</h3>
        <div className="row pb-3">
          <div className="col-3">
            <RiskIndicator
              title="Risk"
              description=""
              value="278"
              subValue="100"
              arrowColor="text-info"
            />
          </div>
          <div className="col-3">
            <RiskIndicator
              title="Control Effectiveness"
              description=""
              value="High"
              subValue="100"
              arrowColor="text-danger"
            />
          </div>
        </div>
        <hr />

        <div className="d-flex align-items-center justify-content-between mt-5">
          <div className="mb-2">
            <h3 className="widget-title">Risk Trend</h3>
            <span className="text-gray-500">Compared to 12% last year</span>
          </div>

          <button className="btn btn-flat text-white flex-center">
            Show more
            <i className="icon-arrow-right text-5c ml-2"></i>
          </button>
        </div>

        <SparkLineChart />

        <div className="d-flex align-items-center justify-content-between mt-5">
          <div className="mb-2">
            <h3 className="widget-title">Top Risks By Group</h3>
            <span className="text-gray-500">3 employees are underutilized</span>
          </div>
          <button className="btn btn-primary">Optimize</button>
        </div>

        <div className="row">
          <div className="col-7 pt-5">
            <VerticalBarChart />
          </div>
          <div className="col-5">
            {riskData.map((data, i) => (
              <div
                className="d-flex align-items-center justify-content-between border-bottom-gray-600 pv-2"
                key={i}
              >
                <div className="mb-2">
                  <h6 className="mb-0">
                    {data.title}
                    {data.isActive && (
                      <span className="dot bg-info ml-2"></span>
                    )}
                  </h6>
                  <small className="fw-300 text-gray-400">
                    Score that indicates your organization's total risk health.
                  </small>
                </div>

                <div className="ml-2 d-inline-flex">
                  <h2 className="fw-300 "> {data.value} </h2>
                  {data.isOnRisk ? (
                    <i className="text-error-400 text-2x icon-arrow-up-right"></i>
                  ) : (
                    <i className="text-info text-2x icon-arrow-down-right"></i>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
